import { render, staticRenderFns } from "./EventsListMap.vue?vue&type=template&id=53512ac8&scoped=true"
import script from "./EventsListMap.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventsListMap.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventsListMap.vue?vue&type=style&index=0&id=53512ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53512ac8",
  null
  
)

export default component.exports